<template>
  <mk-popover
    placement="right"
    trigger="hover"
    :width="width"
    popper-class="popper-class-tag-right"
  >
    <div
      slot="reference"
      class="show-more-button"
    >
      <mk-iconfont icon-class="more">
      </mk-iconfont>
    </div>
    <div>
      <mk-tag
        v-for="(item, index) in tagList"
        :key="index"
        class="tag-item"
      >
        {{ item.tName }}+{{ item.tagScore > 999 ? '999+' : item.tagScore }}
      </mk-tag>
    </div>
  </mk-popover>
</template>

<script>
export default {
  name: 'TagPopover',
  props: {
    tagList: {
      type: Array,
      default: () => {
        return []
      }
    },
    // 同popover witdt属性
    width: {
      type: [Number, String],
      default: '380'
    }
  }
}
</script>

<style lang="scss" scoped>
.icon-mk-more {
  font-size: 12px;
}

.show-more-button {
  display: inline-block;
  box-sizing: border-box;
  width: 25px;
  height: 23px;
  line-height: 21px;
  text-align: center;
  border: 1px solid rgba(0, 0, 0, 0);

  &:hover {
    background-color: #e6efff;
    border: 1px solid #d5e3ff;
    border-radius: 3px;
  }
}

.tag-item {
  margin: 8px 0 0 8px;
  height: 22px;
  line-height: 22px;
  border-radius: 2px;
  padding: 0 8px;
  background: rgba(235, 239, 244, 1);
  color: #6b7b88;
  border: none;
}
</style>

<style lang="scss">
.popper-class-tag-right {
  min-width: 0 !important;
  padding: 2px 0 10px 2px !important;
}
</style>
